import { Button } from 'components/Button/Button';
import styled, { css } from 'styled-components';
import { ReactComponent as CrossIcon } from 'images/icons/cross_24.svg';

export const Wrapper = styled.div`
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: 'Roboto Condensed';

  ${props =>
    props.isSticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 100;
    `}

  background-color: ${props => {
    switch (props.bannerType) {
      case 'error':
        return '#f8d7da';

      case 'success':
        return '#d4edda';

      case 'warning':
        return '#ffc107';

      case 'info':
        return '#1dc4df';

      default:
        return '#fff';
    }
  }};
`;

export const Header = styled.div`
  font-size: 20px;
  font-weight: 700;
  display: flex;
  text-align: ${props => props.isCentered && 'center'};
  align-items: center;
  margin-bottom: 10px;

  color: ${props => {
    switch (props.bannerType) {
      case 'error':
        return '#d51627';
      case 'success':
        return '#155724';

      case 'warning':
        return '#745700';

      case 'info':
        return '#fefefe';

      default:
        return '#000';
    }
  }};
`;

export const HeaderText = styled.div`
  flex-grow: 1;
`;

export const CloseIcon = styled(CrossIcon)`
  cursor: pointer;
  margin-left: auto;
`;

export const Text = styled.div`
  font-size: 14px;
  font-family: 'Roboto';
`;

export const BannerButton = styled(Button)`
  width: 160px;
  font-size: 16px;
`;
